export type UserGrade = 'NORMAL' | 'SCHOOL' | 'TEACHER' | 'ADMIN'

export interface SsoEntitlement {
  productCode: string
  startsAt: string | null
  expiresAt: string | null
}

export interface SsoUser {
  loggedIn: true
  userId: number
  externalUserId: string
  name: string
  email: string | null
  grade: UserGrade
  permissions: string[]
  entitlements: SsoEntitlement[]
}

export interface GuestUser {
  loggedIn: false
  userId?: null
  externalUserId?: null
  name?: null
  email?: null
  grade?: null
  permissions?: string[]
  entitlements?: SsoEntitlement[]
}

export type CurrentUserResponse = SsoUser | GuestUser

export interface AuthExchangeResponse {
  accessToken: string
  tokenType: 'Bearer' | string
  expiresIn: number
  user: SsoUser
}

export type AuthSession = AuthExchangeResponse

export type AuthStatus = 'checking' | 'guest' | 'authenticated' | 'unavailable'

export function isAuthenticatedSsoUser(user: unknown): user is SsoUser {
  if (!user || typeof user !== 'object') return false

  const candidate = user as Partial<SsoUser>
  return (
    candidate.loggedIn === true &&
    typeof candidate.userId === 'number' &&
    typeof candidate.externalUserId === 'string' &&
    typeof candidate.name === 'string' &&
    (typeof candidate.email === 'string' || candidate.email === null) &&
    candidate.grade !== undefined &&
    ['NORMAL', 'SCHOOL', 'TEACHER', 'ADMIN'].includes(candidate.grade) &&
    Array.isArray(candidate.permissions) &&
    candidate.permissions.every((permission) => typeof permission === 'string') &&
    Array.isArray(candidate.entitlements) &&
    candidate.entitlements.every((entitlement) => (
      typeof entitlement === 'object' &&
      entitlement !== null &&
      typeof entitlement.productCode === 'string'
    ))
  )
}
